import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';

const rootId = document.getElementById('root');
const root = createRoot(rootId);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
